// removed by extract-text-webpack-plugin
module.exports = {"Footer":"BottomToolbar__Footer__K1f7z","BottomToolbar":"BottomToolbar__BottomToolbar__3t7G9"};